export function * permute (head, ...tail) {
  let remainder = tail.length ? permute(...tail) : [[]]
  for (let r of remainder) for (let h of head) yield [h, ...r]
}

export function validate (instance, prefix, focusFirstInvalidElement) {
  const allRefs = instance.$refs
  let valid = true
  let firstInvalidElement
  Object.keys(instance.$refs)
    .filter(ref => allRefs[ref] && ref.startsWith(prefix))
    .flat()
    .forEach(ref => {
      const theRef = allRefs[ref]
      if (Array.isArray(theRef)) {
        theRef.forEach(subRef => {
          if (subRef.$props['validation']) {
            valid &= subRef.validate()
            if (focusFirstInvalidElement && !valid && !firstInvalidElement && allRefs[subRef].focus) {
              firstInvalidElement = allRefs[subRef]
            }
          }
        })
      } else if (theRef.$props['validation'] || theRef.validationRules) {
        valid &= allRefs[ref].validate()
        if (focusFirstInvalidElement && !valid && !firstInvalidElement && allRefs[ref].focus) {
          firstInvalidElement = allRefs[ref]
        }
      }
    })

  if (focusFirstInvalidElement && firstInvalidElement) {
    firstInvalidElement.focus()
  }

  return valid
}

export function toggleInArray (array, value) {
  const index = array.indexOf(value)
  if (index >= 0) {
    array.splice(index, 1)
  } else {
    array.push(value)
  }
}

export function applyFiltersToList (list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback) {
  const tempList = JSON.stringify(Object.values(list))
  let result = JSON.parse(tempList)

  const regex = new RegExp(searchKey, 'gmi')

  result = result.filter(item => {
    let matched = false

    fieldsToFilter.forEach(field => {
      matched |= checkMatching(item, field, regex)
    })

    Object.keys(filtersObject).forEach(filter => {
      let value = filtersObject[filter]
      if (typeof value === 'boolean') {
        value = value.toString()
      }
      if (value.length) {
        let itemValue = item[filter]
        if (typeof itemValue === 'boolean') {
          itemValue += ''
        }
        matched &= (itemValue === value) || (Array.isArray(itemValue) && Array.isArray(value) && value.some(element => itemValue.includes(element)))
      }
    })

    return matched
  })

  if (sortingOptions) {
    result.sort((a, b) => {
      const { field, direction } = sortingOptions
      if (a[field] < b[field]) return direction === 'asc' ? -1 : 1
      if (a[field] === b[field]) return 0
      if (a[field] > b[field]) return direction === 'asc' ? 1 : -1
    })
  }

  callback(result)
}

function checkMatching (object, field, pattern) {
  pattern.lastIndex = 0
  return pattern.test(object[field])
}

export function keyBy (arr, key) {
  const result = {}
  if (!arr) return {}
  if (arr && !Object.keys(arr).length) return {}
  arr.forEach(e => {
    if (result[e[key]]) {
      result[e[key]].push(e)
    } else {
      result[e[key]] = [ e ]
    }
  })

  return result
}

export function getErrorMessage (errorObject) {
  if (errorObject.toJSON) {
    return errorObject.toJSON().message
  } else {
    return errorObject.toString()
  }
}

export function setQueryStringVariables (basePath, params) {
  if (!params) {
    return basePath
  }

  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && (typeof params[key] === 'boolean' || params[key].length)) {
      basePath += `${(basePath.includes('?') ? '&' : '?')}${key}=${params[key]}`
    }
  })

  return basePath
}

export function arrayEquals (array1, array2) {
  if (!Array.isArray(array1) || !Array.isArray(array2) || array1.length != array2.length) {
    return false
  }

  return _.isEqual(_.sortBy(array1), _.sortBy(array2))
}

export function objectEquals (object1, object2) {
  if (!object1 || !object2) {
    return false
  }

  const keys1 = Object.keys(object1)
  const keys2 = Object.keys(object2)

  if (keys1.length != keys2.length) {
    return false
  }

  for (let i = 0; i < keys1.length; i++) {
    const key = keys1[i]

    if (object1[key] && !object2[key]) {
      return false
    }

    const value = object1[key]
    const otherValue = object2[key]

    if (typeof value !== 'object') {
      if (value !== otherValue) {
        return false
      }
    } else {
      return objectEquals(value, otherValue)
    }
  }

  return true
}
